import { Box, Grid } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { useTranslation } from "react-i18next";

import { InputLabel, TextInput } from "components";

interface StreetAndHouseNumberProps<T> {
  form: UseFormReturnType<T>;
  streetFieldName: keyof T | string;
  houseNumberFieldName: keyof T | string;
  disabled?: boolean;
}

export const StreetAndHouseNumber = <T,>({
  form,
  streetFieldName,
  houseNumberFieldName,
  disabled = false,
}: StreetAndHouseNumberProps<T>) => {
  const { t } = useTranslation();

  return (
    <Box>
      <InputLabel label={t("user.address.streetAndHouseNumber.label")} required={true} />
      <Grid>
        <Grid.Col span={8}>
          <TextInput
            key={form.key(streetFieldName as string)}
            {...form.getInputProps(streetFieldName)}
            required={true}
            disabled={disabled}
          />
        </Grid.Col>
        <Grid.Col span={4}>
          <TextInput
            key={form.key(houseNumberFieldName as string)}
            {...form.getInputProps(houseNumberFieldName)}
            onBeforeInput={(event: any) => {
              const cursorPos = event.currentTarget.selectionStart || 0;
              if (cursorPos === 0) {
                const inputValue = (event as any).data;
                if (inputValue && !/^[0-9]/.test(inputValue)) {
                  event.preventDefault();
                }
              }
            }}
            required={true}
            disabled={disabled}
          />
        </Grid.Col>
      </Grid>
    </Box>
  );
};
